/**
 * Sends a request to one of this theme's `sh/v1` REST API routes.
 * @param {string} path - The route path, relative to the `sh/v1` namespace (e.g. `ideas/search`).
 * @param {Object} [options] - The configuration details for this request.
 * @param {string} [options.method] - The HTTP method to use. Defaults to `GET`.
 * @param {boolean} [options.include_credentials] - Whether to include the user's session in the request.
 * @param {Object} [options.data] - Data to send as a JSON request body.
 * @param {AbortSignal} [options.signal] - An AbortSignal to cancel the request.
 * @return {Promise} Resolves with the parsed JSON response body on success (2xx); rejects with the
 * parsed WP_Error body (`{code, message, data}`) on failure.
 */
export function rest_request(path, options = {}) {
	const rest_url = document.body.dataset.rest_url;

	const fetch_options = {
		method: options.method || `GET`,
		credentials: options.include_credentials ? `same-origin` : `omit`,
		signal: options.signal,
		headers: {
			'Content-Type': `application/json`,
		},
	};

	if (`data` in options) {
		fetch_options.body = JSON.stringify(options.data);
	}

	return fetch(`${rest_url}${path}`, fetch_options)
		.then((response) =>
			response.json().then((body) => ({
				response,
				body,
			})),
		)
		.then(({ response, body }) => {
			if (!response.ok) {
				throw body;
			}

			return body;
		});
}
